import { Controller } from "stimulus"

export default class extends Controller {
  dismiss(event) {
    const button = event.currentTarget
    const newsId = button.dataset.newsId
    if (!newsId || this._dismissing) return
    this._dismissing = true

    const banner = button.closest('.news-banner')
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(`/dismiss_news/${newsId}`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      }
    }).then(() => {
      if (banner) {
        banner.style.transition = 'opacity 0.3s ease, max-height 0.3s ease'
        banner.style.opacity = '0'
        banner.style.maxHeight = banner.offsetHeight + 'px'
        setTimeout(() => {
          banner.style.maxHeight = '0'
          banner.style.overflow = 'hidden'
          banner.style.padding = '0'
          banner.style.borderWidth = '0'
        }, 150)
        setTimeout(() => {
          banner.remove()
          const container = document.getElementById('news-banners-container')
          if (container && container.querySelectorAll('.news-banner').length === 0) {
            container.remove()
          }
        }, 350)
      }
    }).catch(() => {
      this._dismissing = false
    })
  }
}
